module.exports = __webpack_public_path__ + "static/media/timelapse.f781c04c.svg";